import React from 'react';
import { storage } from '@uhg-abyss/web/tools/storage';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useForm as useAbyssForm } from '@uhg-abyss/web/hooks/useForm';

const textStyle = {
  height: '70px',
  marginTop: '-25px',
  marginLeft: '-6px',
};

const Image = styled('div', {
  maxWidth: '50%',
});
export const Signature = () => {
  const form = useAbyssForm();
  const signatureType = form.getValues('attestation.signatureRadio');
  const isTyped = signatureType === 'Text';
  const signatureImgDraw = storage.local.get('signature-draw');
  const signatureImgType = storage.local.get('signature-type');

  return (
    <Image>
      <img
        id="attestation-signature-value"
        style={isTyped ? textStyle : null}
        src={isTyped ? signatureImgType : signatureImgDraw}
        alt=""
      />
    </Image>
  );
};
